import api from '../utils/api';

const surveyService = {
  summary: () => api.get('/api/surveys/summary'),
  list: () => api.get('/api/surveys'),
  create: (data) => api.post('/api/surveys', data),
  results: (id) => api.get(`/api/surveys/${id}/results`),
  submit: (id, data) => api.post(`/api/surveys/${id}/responses`, data),
};

export default surveyService;